export const LOCAL_CONSTANT = {

  /**
   * 書類名
   * @type {string}
   */
  DOCUMENT_NAME: '包括委任状提出書',

  /**
   * 説明
   * @type {string}
   */
  DISCRIPTION: '特殊申請の書類PDFの作成を支援するツールです。',

  /**
   * バージョン
   * @type {string}
   */
  VERSION: '1.1.0版',

  /**
   * 法人格
   * @type {string[]}
   */
  LEGAL_PERSONALITIES: [
    '会社',
    '法人'
  ],

  /**
   * 委任事項「すべての国際出願に関する一切の件」にチェックした場合に表示するメッセージ
   * @type {string}
   */
  MESSAGE_INCLUDING_PCT_PROCEDURES: 'PCT国際出願関係手続の委任状には押印が必要です（令和２年１２月２８日以降、押印に加えて署名での手続も可能です）。\nそのため、押印又は署名のない包括委任状は、PCT手続では援用できません。',

  /**
   * 受任者と委任者間で合意が必要な旨のメッセージ
   * @type {string}
   */
  MESSAGE_IMPORTANT_NOTICE_REGARDING_USAGE: '包括委任状は委任者及び選任した代理人両者の合意がなければ作成できません。ご理解の上、ご利用ください。'
};